// URL friendly names for Loan Products
export default {
    car: 'car',
    carElectric: 'car-electric',
    carNoInsurance: 'car-no-insurance',
    mc: 'mc',
    atv: 'atv',
    snowmobile: 'snowmobile',
    campingCar: 'camping',
    campingCaravan: 'caravan',
    boat: 'boat',
};
